import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { useState, useEffect  } from 'react'

import About from './components/about/About';
import Contact from './components/contact/Contact';
import Feedback from './components/feedback/Feedback';
import Footer from './components/footer/Footer';

import Hero from './components/hero/Hero';
import Team from './components/team/Team';
import Services from './components/services/Services';
import WebDevelopment from './components/services/WebDevelopment';
import MobileDevelopment from './components/services/MobileDevelopment';
import CloudSolutions from './components/services/CloudSolutions';
import UiUxDesign from './components/services/UiUxDesign';
import Loading from './components/loading/Loading';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import TermsOfService from './components/legal/TermsOfService';
import CookiePolicy from './components/legal/CookiePolicy';
import SubmitFeedback from './components/feedback/SubmitFeedback';
import ThankYou from './components/feedback/ThankYou';
import FloatingNav from './components/common/FloatingNav';

function App() {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false)
    }, 2000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <Router>
      <div className="App">
        <AnimatePresence mode='wait'>
          {loading && <Loading />}
        </AnimatePresence>
        
        {!loading && (
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <About />
                <Team />
                <Feedback />
                <Contact />
              </>
            } />
            <Route path="/services" element={<Services />} />
            <Route path="/services/web-development" element={<WebDevelopment />} />
            <Route path="/services/mobile-development" element={<MobileDevelopment />} />
            <Route path="/services/cloud-solutions" element={<CloudSolutions />} />
            <Route path="/services/ui-ux-design" element={<UiUxDesign />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/contact" element={<Contact/>} />
            <Route path="/submit-feedback" element={<SubmitFeedback />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
        )}
         <FloatingNav />
        <Footer />
      </div>
    </Router>
  )
}

export default App;
